// extracted by mini-css-extract-plugin
export default {"logo":"SideBar_logo__uYQ16","btn":"SideBar_btn__xn2JC","resumeBtn":"SideBar_resumeBtn__eTqdA"};